export class LCInput {
  public topologyId: string;
  public startDate: string;
  public endDate: string;
}
